<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-07-01 11:40:58 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-07-10 16:08:47 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/oppty-card/src/izt-oppty-card.vue
 * @Description  : 商机卡片
-->
<style lang="scss" scoped>
.izt-oppty-card-container {
  background: #FFFFFF;
  box-shadow: 0px 5px 6px 0px rgba(0,0,0,0.1);
  border-radius: 24px;
  min-height: 0;
  overflow: hidden;
  color: rgba($color: #000000, $alpha: 0.65);
  .head-area-container {
    .name-and-type {
      padding: 24px;
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .name {
        font-weight: 500;
        font-size: 24px;
        color: rgba(0,0,0,0.65);
      }
    }
    .oppty-name {
      padding: 16px 24px;
      background-color: var(--izt-theme-color);
      color: var(--izt-theme-text-color-65);
      font-weight: bold;
      font-size: 28px;
    }
  }
  .main-container {
    padding: 24px;
    .rec-short {
      margin: 16px 0;
    }
    .description {
      font-weight: 400;
      font-size: 26px;
      color: rgba(0,0,0,0.65);
    }
  }
}
</style>

<template>
  <div class="izt-oppty-card-container" @click.stop="emit('click', {data, type: 'oppty'})">
    <div class="head-area-container">
      <div class="name-and-type">
        <div class="name">展商名称</div>
        <div class="real-label type">商机</div>
      </div>
      <div class="oppty-name">精彩呈现！多款韩国食品、饮料进入供应</div>
    </div>
    <div class="main-container">
      <izt-album :list="list" size="large" preview />
      <div class="rec-short">
        <izt-ai-rec-short text="专注韩式炒年糕品类，以自主配方驱动"/>
      </div>
      <div class="description">熟滋专注韩式炒年糕品类，以自主配方驱动，提供“小麦糕条+韩式炒年糕粉”组合方案，解决传统年糕易煮</div>
    </div>
  </div>
</template>

<script setup name="izt-oppty-card">
  import { computed } from 'vue'
  defineOptions({ name: 'izt-oppty-card' })

  defineProps({
    data: { type: Object, default: () => ({}) }
  })

  const emit = defineEmits(['click'])

  const list = computed(() => {
    let num = 5
    return Array.from({ length: num }, (_, i) => ({
      id: i + 1,
      src: `https://picsum.photos/200/300?random=${i + 1}`
    }))
  })
</script>